export class ReturnCheckModel {
    cashreg_sequence: number;
    cashreg_date: Date;
    check_card: string;
    amount_of_pay: number;

    constructor(
        cashreg_sequence: number,
        cashreg_date: Date,
        check_card: string,
        amount_of_pay: number
    ) {
        this.cashreg_sequence = cashreg_sequence;
        this.cashreg_date = cashreg_date;
        this.check_card = check_card;
        this.amount_of_pay = amount_of_pay;
    }
}
